import React from 'react';

import { CountryList } from 'models/countryList';

type SelectItemInputProps = {
  value?: any;
  onChange?(value: any): void;
  id?: string;
  className?: string;
  name?: string;
  ref?: any;
  defaultValue?: string;
};
const CountrySelectInput: React.FC<SelectItemInputProps> = props => {
  return (
    <select {...props}>
      <option value="">Select your country</option>
      {CountryList.countries
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map(country => (
          <option value={country.code} key={country.code}>
            {country.name}
          </option>
        ))}
    </select>
  );
};

export default CountrySelectInput;
